module.exports = __webpack_public_path__ + "static/media/closeWhiteCircle.27146fb1.svg";